export default __webpack_public_path__ + "static/capitaloneoffice-6ae2d662b561af8be9fc8bcb7fae1985.png";